"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionFeatures = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const styled_components_1 = __importStar(require("styled-components"));
const Subtitle_1 = require("../../atoms/Subtitle/Subtitle");
const FeaturesTable_1 = __importDefault(require("../../molecules/FeaturesTable/FeaturesTable"));
function SubscriptionFeatures({ t, isActiveTrial, handleSignIn, isLandscape, isMobile, }) {
    return ((0, jsx_runtime_1.jsx)(Container, { "data-e2e": 'SubscriptionFeatures_Container', children: (0, jsx_runtime_1.jsxs)(TableContainer, { "data-e2e": 'SubscriptionFeatures_TableContainer', children: [(0, jsx_runtime_1.jsx)(FeaturesTable_1.default, { t: t, "data-e2e": 'SubscriptionFeatures_FeaturesTable' }), !isActiveTrial && ((0, jsx_runtime_1.jsxs)(DescriptionContainer, { isLandscape: isLandscape, isMobile: isMobile, "data-e2e": 'SubscriptionFeatures_DescriptionContainer', children: [(0, jsx_runtime_1.jsx)(Description, { "data-e2e": 'SubscriptionFeatures_Description', children: t('userOnboarding.subsSheet.description') }), (0, jsx_runtime_1.jsx)(Description, { "data-e2e": 'SubscriptionFeatures_Description', children: (0, jsx_runtime_1.jsx)(i18n_1.Trans, { i18nKey: "userOnboarding.subsSheet.signIn", components: {
                                    1: ((0, jsx_runtime_1.jsx)(LoginLink, { tabIndex: 0, onKeyDown: e => {
                                            if (e.key === 'Enter')
                                                handleSignIn();
                                        }, onClick: () => handleSignIn() })),
                                }, "data-e2e": 'SubscriptionFeatures_Trans' }) })] }))] }) }));
}
exports.SubscriptionFeatures = SubscriptionFeatures;
const Container = styled_components_1.default.div ``;
const TableContainer = styled_components_1.default.div `
  justify-content: center;
  display: flex;
  flex-direction: column;
`;
const DescriptionContainer = styled_components_1.default.div `
  background: linear-gradient(to right, transparent, #11151c 4%, transparent),
    linear-gradient(to left, transparent, #11151c 4%, transparent);

  margin: 1.25em 0;
  padding: 1em 10% 0;

  ${({ isMobile, isLandscape }) => isMobile && !isLandscape && `padding: 0em;`};

  ${({ isMobile }) => !isMobile &&
    ui_1.device.tablet((0, styled_components_1.css) `
        padding: 0 1em;
      `)}
`;
const Description = (0, styled_components_1.default)(Subtitle_1.Subtitle) `
  font-size: 14px;
  color: #a2a7aa;
  margin: 0.5em 0em;
`;
const LoginLink = styled_components_1.default.a `
  text-decoration: underline;

  &:focus-visible {
    outline: 2px solid #47cfcb;
    outline-offset: 2px;
  }
`;
